<div class="no-results justify-center items-center flex-col">
  <mat-icon>search</mat-icon>
  <span>{{ title ? title : ('generic.no_results' | translate) }}</span>
  <ng-content></ng-content>
</div>
